export default "__VITE_ASSET__BPef4HdT__"